module.exports = __webpack_public_path__ + "img/3_par.ea406f9d.jpg";